import axios from "axios";
import { configureAxiosAuth } from "../../utils/auth";

// Base URL for API requests
const API_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:3001";

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Configure axios to include auth token in all requests
configureAxiosAuth(api);

export { configureAxiosAuth };
export default api;
